
       <div class="card-right">
        <div class="card-header">
        <h6>{{ cardData?.parsedObjectData?.['Service']}}</h6>
        <div class="pin-buttons">
            <button mat-button1 title="Click Pin to make it default" *ngIf="!checkDefaultPinService() && !cardData?.apiFailed" (click)="makeDefaultService(cardData?.parsedObjectData?.['Service'])" >
                <span><f-icon icon-config='{"iconName": "thumbtack", "iconType": "solid", "iconSize": "s", "iconColor": "#949494"}'></f-icon></span></button>
       
             <button mat-button1 title="Default Service" *ngIf="checkDefaultPinService() && !cardData?.apiFailed">
                 <span><f-icon class="green" icon-config='{"iconName": "thumbtack", "iconType": "solid", "iconSize": "s", "iconColor": "green"}'></f-icon></span></button>
        </div>
        </div>
        <p>
        <span><strong>Service Info:</strong></span>
        <span>{{cardData?.parsedObjectData?.['Service Center Name'] }}</span>
        <span> {{cardData?.parsedObjectData?.['Phone']}}</span>
        <span>{{ cardData?.parsedObjectData?.['URL']}} </span></p>
        <p *ngIf="!cardData?.apiFailed">
        <span> <strong>Greeting:</strong></span> 
        <span>{{getGreeting(cardData?.parsedObjectData?.['Greeting'] ,  cardData?.parsedObjectData?.['Service Center Name'])}}</span>
    </p>
        <p *ngIf="!cardData?.apiFailed"><strong>Terminology for Employees:</strong>
        <span>{{cardData?.parsedObjectData?.['Title']}}</span>
    </p>
      </div> 


      